<div class="app-group">
  <div class="group-name">
    <h3>Group Name</h3>
    <div class="row-wrap">
      <mat-form-field class="language-selector">
        <mat-select [(ngModel)]="currentLang" >
          @for (lang of languages; track lang) {
            <mat-option [value]="lang">{{lang}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @for (lang of languages; track lang) {
        <div>
          @if (lang == currentLang) {
            <mat-form-field>
              <mat-label>Group name</mat-label>
              <input type="text" matInput [formControl]="getNameControl(lang)" />
            </mat-form-field>
          }
        </div>
      }
    </div>
  </div>
  <app-list-selector [parentFormGroup]="parentFormGroup" [appList]="appGroup.appIds" [caption]="'Add App to Group'"
  [controlName]="'appIds'"></app-list-selector>
  <color-picker [title]="'Set background color?'" [showColorPicker]="!!appGroup.backgroundColor"
    [hexColor]="appGroup.backgroundColor" [parentFormGroup]="parentFormGroup" [controlName]="'backgroundColor'"
  [showColorPickerControlName]="'setBackgroundColor'"></color-picker>
</div>
